import type {
  DataTableDataSearchDto,
  TableDataDtoResponse,
} from '@asset-metrix/portal-gateway-client-js';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export type InvestmentComplianceLimitPreviewParams = {
  contentId: string;
  dataLevelIndex: number;
  limit: number;
  offset: number;
  selection: DataTableDataSearchDto['selection'];
};

export const getInvestmentComplianceLimitPreview = async ({
  contentId,
  dataLevelIndex,
  limit,
  offset,
  selection,
}: InvestmentComplianceLimitPreviewParams): Promise<TableDataDtoResponse> => {
  const response =
    await portalGatewayClient.table.getInvestmentComplianceLimitPreview(
      contentId,
      String(dataLevelIndex),
      { limit, offset },
      { selection }
    );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(
        response.error,
        'Error loading investment compliance limit preview.'
      ),
      response
    );
  }

  return response.data;
};
